import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagSearch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 21,
	viewBox: "0 0 19 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8 11.4293C7.06536 10.5132 5.80876 10 4.5 10C3.19124 10 1.93464 10.5132 1 11.4293M1 11.4293V2.42929C1.93464 1.51315 3.19124 1 4.5 1C5.80876 1 7.06536 1.51315 8 2.42929C8.93464 3.34542 10.1912 3.85857 11.5 3.85857C12.8088 3.85857 14.0654 3.34542 15 2.42929V8.42929M1 11.4293V18.4293M16.2 17.6293L18 19.4293M11 15.4293C11 16.2249 11.3161 16.988 11.8787 17.5506C12.4413 18.1132 13.2044 18.4293 14 18.4293C14.7956 18.4293 15.5587 18.1132 16.1213 17.5506C16.6839 16.988 17 16.2249 17 15.4293C17 14.6336 16.6839 13.8706 16.1213 13.308C15.5587 12.7454 14.7956 12.4293 14 12.4293C13.2044 12.4293 12.4413 12.7454 11.8787 13.308C11.3161 13.8706 11 14.6336 11 15.4293Z",
		stroke: "currentColor ",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgFlagSearch);
export { ForwardRef as ReactComponent };
